import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H3, Button, CONSUMER_APP_URL } from 'shared';
const ExistsEDS = () => {
    const handleRedirect = () => {
        if (CONSUMER_APP_URL) {
            window.location.href = CONSUMER_APP_URL;
        }
    };
    return (_jsx("div", { className: "max-width-600 min-height-600 mar-auto flex-center pad-20 align-start-touch", children: _jsxs("div", { className: "text-center", children: [_jsx(H3, { children: "Thank you for your interest. You have an existing account with us. Please contact our support team for further assistance." }), _jsx("div", { className: "mar-t-40", children: _jsx(Button, { type: "button", onClick: handleRedirect, className: "button-primary", children: "Return to Consumer Portal" }) })] }) }));
};
export default ExistsEDS;
